import React, { useEffect, useRef, useState } from "react";
import { showToast } from "../../../Common/Messages";
import DropdownCheckList from "../../../Common/DropdownCheckList";

const DocInfo = (props) => {
    const documentList = props.docData.relationInfo || [];
    const tagList = props.docData.tag || [];
    const faqList = props.docData.faq || [];
    const accessList = props.docData.access || [];
    const accessType = props.accessType || [];
    const [editingTag, setEditingTag] = useState(null);
    const [tagDraft, setTagDraft] = useState("");
    const isComposing = useRef(false);

    useEffect(() => {
        if (props.isViewMode) setEditingTag(null);
    }, [props.isViewMode]);

    const openSearchDoc = (e, from) => {
        props.openSearchDoc(from);
    }
    const removeRelatedDoc = (item, type) => {
        props.removeRelatedDoc(item, type);
    }

    const handleComposition = (e) => {
        // 태그 입력시, 한글 입력 완료 여부 확인
        if (e.type === 'compositionstart') {
            isComposing.current = true;
        } else if (e.type === 'compositionend') {
            isComposing.current = false;
        }
    };
    const handleEnterTag = (e) => {
        if (e.key !== "Enter" || isComposing.current || e.nativeEvent.isComposing || e.keyCode === 229) {
            return;
        }
        const tag = e.target.value.trim();
        if (!tag || tag === "") {
            e.target.value = "";
            showToast('warning', "태그를 입력해주세요.");
            return;
        }

        for (let i = 0; i < tagList.length; i++) {
            if (tagList[i].trim().toLowerCase() === tag.toLowerCase()) {
                e.target.value = "";
                showToast('warning', "중복된 태그입니다.");
                return;
            }
        }
        props.setDocData(prev => {
            const prevTagList = prev.tag ?? [];
            return { ...prev, tag: [...prevTagList, tag] }
        });
        e.target.value = "";
    };
    const handleDeleteTag = (tag) => {
        const list = tagList.filter(t => t !== tag);
        props.setDocData(prev => { return { ...prev, tag: list } });
    };

    const saveTag = () => {
        const tag = tagDraft.trim();
        if (!tag) {
            showToast('warning', "태그를 입력해주세요.");
            return;
        }
        if (tagList.some(item => item !== editingTag && item.trim().toLowerCase() === tag.toLowerCase())) {
            showToast('warning', "중복된 태그입니다.");
            return;
        }
        props.setDocData(prev => ({ ...prev, tag: (prev.tag || []).map(item => item === editingTag ? tag : item) }));
        setEditingTag(null);
    };

    const handleEditTagKeyDown = (e) => {
        if (isComposing.current || e.nativeEvent.isComposing || e.keyCode === 229) return;
        if (e.key === "Enter") {
            e.preventDefault();
            saveTag();
        } else if (e.key === "Escape") {
            setEditingTag(null);
        }
    };

    const access = (accessType, list) => {
        return (
            <div className="doclist-wrap">
                <div className="cate-top">
                    <h4 className="cate-title">접근 권한</h4>
                </div>
                <DropdownCheckList list={accessType} items={list} setItems={(data) => {props.setDocData(prev => { return { ...prev, access: data } })}} disabled={props.isViewMode}/>
            </div>
        )
    }
    const tag = (list) => {
        return (
            <div className="related-item tag">
                <div className="cate-top">
                    <h4 className="cate-title">태그</h4>
                    {!props.isViewMode && props.onExtractTags &&
                        <button type="button" className="btn-add"
                            onClick={props.onExtractTags}
                            disabled={props.isExtractingTags || !props.canExtractTags}
                            aria-busy={props.isExtractingTags}
                            style={{ opacity: props.isExtractingTags || !props.canExtractTags ? 0.6 : 1,
                                cursor: props.isExtractingTags || !props.canExtractTags ? 'not-allowed' : 'pointer' }}
                        >
                            {props.isExtractingTags ? '추출 중...' : '키워드 추출'}
                        </button>
                    }
                </div>
                {!props.isViewMode &&
                    <div className="searchbox-tag">
                        <i className="icoKdc20 add-g"></i>
                        <input type="text" placeholder="추가할 태그를 입력하고 엔터를 누르세요."
                            onCompositionStart={handleComposition}
                            onCompositionEnd={handleComposition}
                            onKeyDown={handleEnterTag}
                        />
                    </div>
                }
                <div className="tag-list">
                    {list.length > 0 && list.map((x, index) => {
                        return (
                            <div key={index} className="tag-each">
                                {!props.isViewMode && editingTag === x ? <>
                                    <input type="text" aria-label="태그 수정" value={tagDraft} autoFocus
                                        style={{ width: '110px', minWidth: 0 }}
                                        onChange={e => setTagDraft(e.target.value)}
                                        onCompositionStart={handleComposition}
                                        onCompositionEnd={handleComposition}
                                        onKeyDown={handleEditTagKeyDown} />
                                    <button type="button" onClick={saveTag}>저장</button>
                                    <button type="button" onClick={() => setEditingTag(null)}>취소</button>
                                </> : <>
                                    <span>{x}</span>
                                    {!props.isViewMode && <>
                                        <button type="button" aria-label={`${x} 태그 수정`} onClick={() => {
                                            setEditingTag(x);
                                            setTagDraft(x);
                                        }}>수정</button>
                                        <button type="button" aria-label={`${x} 태그 삭제`} onClick={() => handleDeleteTag(x)}>
                                            <i className="icoKdc12 delete"></i>
                                        </button>
                                    </>}
                                </>}
                            </div>
                        )
                    })}
                </div>
            </div>);
    }
    const documents = (list) => {
        const path = (pathItem) => {
            return (
                <div className="path">
                    {pathItem.map((x, index) => {
                        return (
                            <React.Fragment key={index}>
                                <span className='docbox-col-path-text'>{x}</span>
                                {index < pathItem.length - 1 && <i className="icoKdc12 next"></i>}
                            </React.Fragment>
                        )
                    })}
                </div>
            );
        }
        return (
            <div className="doclist-wrap">
                <div className="cate-top">
                    <h4 className="cate-title">관련문서</h4>
                    {!props.isViewMode &&
                        <button className="btn-add" onClick={e => openSearchDoc(e, 'menu')} >
                            <i className="icoKdc20 add-g"></i>
                        </button>
                    }
                </div>
                {
                    list && list.map(x => {
                        const pathItem = x.fullPath ? JSON.parse(x.fullPath) : [];
                        const title = x.title;
                        return (
                            <div className="doclist">
                                <div className="doclist-title">
                                    {path(pathItem)}
                                    <p className='docbox-col-title' onClick={e => { }}>{title}</p>
                                </div>
                                {!props.isViewMode &&
                                    <button className="btn-delete" onClick={e => removeRelatedDoc(x, "relationInfo")}>
                                        <i className="icoKdc20 delete"></i>
                                    </button>
                                }
                            </div>
                        );
                    }
                    )
                }
            </div>
        );
    }
    const faq = (list) => {
        return (
            <div className="doclist-wrap">
                <div className="cate-top">
                    <h4 className="cate-title">FAQ</h4>
                    {!props.isViewMode &&
                        <button className="btn-add" onClick={e => openSearchDoc(e, 'faq')} >
                            <i className="icoKdc20 add-g"></i>
                        </button>
                    }
                </div>
                {
                    list && list.map(x => {
                        const title = x.question;
                        return (
                            <div className="doclist">
                                <div className="doclist-title">
                                    <div className="path">
                                        <span className='docbox-col-path-text'>{x.faqKindName}</span>
                                    </div>
                                    <p className='docbox-col-title' onClick={e => { }}>{title}</p>
                                </div>
                                {!props.isViewMode &&
                                    <button className="btn-delete" onClick={e => removeRelatedDoc(x, "faq")}>
                                        <i className="icoKdc20 delete"></i>
                                    </button>
                                }
                            </div>
                        );
                    }
                    )
                }
            </div>
        );
    }
    return (
        <div className="editor-side">
            <div className="editor-side-top">
                <h3 className='title'>관련정보</h3>
                <button className="btn-close" onClick={props.onClose}>
                    <i className="icoKdc32 close"></i>
                </button>
            </div>
            <div className="editor-side-cnts">
                {access(accessType, accessList)}
                {tag(tagList)}
                {documents(documentList)}
                {faq(faqList)}
            </div>
        </div>
    )
}
export default DocInfo;
